import { OrganizationId } from 'common/src/generated/types';

export const LocalStorageKeys = {
    AUTH_EMAIL: 'heavent-auth-email',
    BACKOFFICE_INVOICES_COLUMNS: 'heavent-backoffice-invoices-columns',
    BACKOFFICE_IS_ACTIVE: 'heavent-backoffice-is-active',
    BACKOFFICE_IS_ADMIN: 'heavent-backoffice-is-admin',
    BACKOFFICE_SEARCH: 'heavent-backoffice-search',
    BACKOFFICE_SORT: 'heavent-backoffice-sort',
    CURRENT_EVENT_ID: 'heavent-current-event-id',
    CURRENT_EVENT_NAME: 'heavent-current-event-name',
    CURRENT_ORGANIZATION_ID: 'heavent-current-organization-id',
    DELEGATIONS_SPACE_TAB: 'heavent-delegations-space-tab',
    EVENT_ID: 'heavent-event-id',
    HIDE_HUBSPOT: 'hide-hubspot',
    ORGANIZATION_ID: 'heavent-organization-id',
    POSITIONS_IMPORT_FORMATS: 'heavent-positions-import-formats',
    POSITIONS_IMPORT_MAPPINGS: 'heavent-positions-import-mappings',
    POSITIONS_IMPORT_MODE: 'heavent-positions-import-mode',
    POSITIONS_IMPORT_PRESETS: (organizationId: OrganizationId) =>
        `heavent-positions-import-presets-${organizationId}`,
    VOLUNTEERS_IMPORT_FORMATS: 'heavent-volunteers-import-formats',
    VOLUNTEERS_IMPORT_MAPPINGS: 'heavent-volunteers-import-mappings',
    VOLUNTEERS_IMPORT_MODE: 'heavent-volunteers-import-mode',
    VOLUNTEERS_IMPORT_PRESETS: (organizationId: OrganizationId) =>
        `heavent-volunteers-import-presets-${organizationId}`,
    DELEGATIONS_IMPORT_FORMATS: 'heavent-delegations-import-formats',
    DELEGATIONS_IMPORT_MAPPINGS: 'heavent-delegations-import-mappings',
    DELEGATIONS_IMPORT_PRESETS: (organizationId: OrganizationId) =>
        `heavent-delegations-import-presets-${organizationId}`,
    DELEGATIONS_IMPORT_MODE: 'heavent-delegations-import-mode',
    DELEGATION_MEMBERS_IMPORT_FORMATS: 'heavent-delegation-members-import-formats',
    DELEGATION_MEMBERS_IMPORT_MAPPINGS: 'heavent-delegation-members-import-mappings',
    DELEGATION_MEMBERS_IMPORT_PRESETS: (organizationId: OrganizationId) =>
        `heavent-delegation-members-import-presets-${organizationId}`,
    DELEGATION_MEMBERS_IMPORT_MODE: 'heavent-delegation-members-import-mode'
};
